import { all, call, put, select, takeLatest } from "redux-saga/effects";

import { PagedResponse, QueryParams } from "@ofqual/portal-core/core/types";
import { ActionPayload, loadedActivities, loadedThreads } from "./actions";
import { LOADING_ACTIVITIES, LOADING_THREADS } from "./constants";
import { authSelector } from "./selectors";
import { Activity } from "../domain/Activity";
import { activitiesService, threadedMessageService } from "../services";

function* watchActivitiesSaga() {
  yield takeLatest(LOADING_ACTIVITIES, activitesSaga);
}

function* watchThreadedMessagesSaga() {
  yield takeLatest(LOADING_THREADS, threadedMessagesSaga);
}

function* activitesSaga({
  payload,
}: ActionPayload<{
  resourceId: string;
  params: QueryParams;
}>) {
  const { resourceId, params } = payload;
  const { token } = yield select(authSelector);

  const activities: PagedResponse<Activity> = yield call(
    [activitiesService, activitiesService.search],
    resourceId,
    { ...params },
    { token }
  );
  yield put(loadedActivities(resourceId, activities));
}

function* threadedMessagesSaga({
  payload,
}: ActionPayload<{
  resourceId: string;
}>) {
  const { resourceId } = payload;
  const { token } = yield select(authSelector);

  const listOfThreads: PagedResponse<Activity> = yield call(
    [threadedMessageService, threadedMessageService.getPublicMessageThreads],
    resourceId,
    { token }
  );

  yield put(loadedThreads(resourceId, listOfThreads));
}



export function* rootSaga() {
  yield all([
    watchActivitiesSaga(),
    watchThreadedMessagesSaga()
    // further sagas...
  ]);
}
